import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiShield, FiMapPin, FiThumbsUp, FiAward, FiCheckCircle } = FiIcons;

const badges = [
  { icon: FiAward, label: "Veteran Owned", sub: "Discipline & Precision" },
  { icon: FiStar, label: "Premium Results", sub: "Every time" },
  { icon: FiShield, label: "Fully Insured", sub: "Peace of mind" },
  { icon: FiMapPin, label: "Jacksonville Local", sub: "Serving NE Florida" },
  { icon: FiThumbsUp, label: "Satisfaction Guaranteed", sub: "No shortcuts" },
  { icon: FiCheckCircle, label: "Pro-Grade Products", sub: "Industry leading" },
];

export default function TrustBadges() {
  return (
    <section className="py-10 bg-slate-900 border-y border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {badges.map((badge, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06 }}
              className="flex flex-col items-center text-center gap-2 py-4"
            >
              <badge.icon className="text-blue-500 text-2xl" />
              <span className="text-white text-xs font-bold uppercase tracking-wide">{badge.label}</span>
              <span className="text-slate-500 text-xs">{badge.sub}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}